// extracted by mini-css-extract-plugin
export default {"content":"styles_content__GPBqo","modal":"styles_modal__BYLoV"};